import { createContext } from "react";

const QRTransferContext = createContext();

export default QRTransferContext;
